import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom/dist";
import TooltipIcons from "../../../../core/common/tooltip-content/tooltipIcons";
import RefreshIcon from "../../../../core/common/tooltip-content/refresh";
import CollapesIcon from "../../../../core/common/tooltip-content/collapes";
import CommonFooter from "../../../../core/common/footer/commonFooter";
import ViewEmpShifts from "./ViewEmpShifts";
import Table from "../../../../core/pagination/datatable";
import { ROLL_CALL_API_BASE_URL } from "../RollCallConfig/RollCallConfig";
import { Select, Spin } from "antd";
import Swal from "sweetalert2";
import { DatePicker } from "antd";
import dayjs from "dayjs";
const { RangePicker } = DatePicker;

const RollcallAssignShifts = () => {
  const [empData, setEmpData] = useState([]);
  const [deptData, setDeptData] = useState([]);
  const [shiftTypes, setShiftTypes] = useState([]);
  const [selectedDep, setSelectedDep] = useState(null);

  const [tokenData, setTokenData] = useState(null);
  const [superIdData, setSuperIdData] = useState(null);
  const [selectedShift, setSelectedShift] = useState(null);
  const [selectedpreShift, setSelectedpreShift] = useState(null);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  // const [selectedEmp, setSelectedEmp] = useState(null);
  const [selectedEmployees, setSelectedEmployees] = useState([]);
  const [loading, setloading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const token = sessionStorage.getItem("authToken");
    const superId = sessionStorage.getItem("superId");

    if (token && superId) {
      setTokenData(token);
      setSuperIdData(superId);
    } else {
      console.warn("User data not found in sessionStorage");
      navigate("/signin");
    }
  }, [navigate]);

  useEffect(() => {
    if (tokenData && superIdData) {
      console.log("Token:", tokenData);
      console.log("SuperId:", superIdData);
    }
  }, [tokenData, superIdData]);

  useEffect(() => {
    if ((tokenData, superIdData)) {
      const fetchDepartments = async () => {
        try {
          const response = await fetch(
            `${ROLL_CALL_API_BASE_URL}portal/department/getdepartment?superid=${superIdData}`,
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${tokenData}`,
              },
            }
          );

          if (!response.ok) {
            throw new Error("Failed to fetch departments");
          }
          const data = await response.json();

          // Correct the check for status
          if (data.status) {
            const activeRecords = data.ResultData?.filter(
              (item) => item.isactive
            );
            setDeptData(activeRecords);
          } else {
            console.error("Invalid department response structure:", data);
          }
        } catch (error) {
          console.error("Error fetching departments:", error.message);
        }
      };
      fetchDepartments();
    }
  }, [superIdData, tokenData]);

  useEffect(() => {
    if ((tokenData, superIdData)) {
      setloading(true);
      const fetchEmployeeData = async () => {
        try {
          const response = await fetch(
            `${ROLL_CALL_API_BASE_URL}portal/emp/getEmployee?superid=${superIdData}&departmentid=&regid=`,
            {
              method: "GET",
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${tokenData}`,
              },
            }
          );

          if (!response.ok) {
            throw new Error("Failed to fetch employees");
          }

          const data = await response.json();
          if (data.status) {
            setEmpData(data.ResultData || []);
          } else {
            console.error("Error fetching employees:", data.ErrorMsg);
          }
        } catch (error) {
          console.error("Error fetching employees:", error);
        } finally {
          setloading(false);
        }
      };

      fetchEmployeeData();
    }
  }, [superIdData, tokenData]);

  useEffect(() => {
    if ((superIdData, tokenData)) {
      const fetchShiftTypes = async () => {
        try {
          const response = await fetch(
            `${ROLL_CALL_API_BASE_URL}portal/shifts/getShiftsTypes?superid=${superIdData}`,
            {
              method: "GET",
              headers: {
                Authorization: `Bearer ${tokenData}`,
                "Content-Type": "application/json",
              },
            }
          );

          if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
          }

          const data = await response.json();
          setShiftTypes(data.ResultData);
        } catch (err) {
          console.log(err.message);
        }
      };
      fetchShiftTypes();
    }
  }, [tokenData, superIdData]);

  useEffect(() => {
    if (tokenData && superIdData && selectedDep) {
      setloading(true);
      const fetchEmployeesByDept = async () => {
        try {
          const empResponse = await fetch(
            `${ROLL_CALL_API_BASE_URL}portal/department/getEmpByDept?departmentid=${selectedDep}&superid=${superIdData}`,
            {
              method: "GET",
              headers: {
                Authorization: `Bearer ${tokenData}`,
                "Content-Type": "application/json",
              },
            }
          );
          const empsData = await empResponse.json();

          if (empsData["status"]) {
            console.log(empsData);
            setEmpData(empsData["ResultData"]);
          } else {
            console.log(
              "Failed to fetch eployees by department:",
              empsData.Message
            );
          }
        } catch (error) {
          console.error(
            "Error fetching eployees by department:",
            error.message
          );
        } finally {
          setloading(false);
        }
      };

      fetchEmployeesByDept();
    }
  }, [tokenData, superIdData, selectedDep]);

  useEffect(() => {
    setloading(true);
    if (superIdData && tokenData && selectedpreShift) {
      const fetchEmployeesByShift = async () => {
        try {
          console.log(selectedShift);
          const empResponse = await fetch(
            `${ROLL_CALL_API_BASE_URL}portal/shifts/getEmpByShift?shiftid=${selectedpreShift}&superid=${superIdData}`,
            {
              method: "GET",
              headers: {
                Authorization: `Bearer ${tokenData}`,
                "Content-Type": "application/json",
              },
            }
          );
          const empsData = await empResponse.json();

          if (empsData["status"]) {
            console.log(empsData);
            setEmpData(empsData["ResultData"]);
          } else {
            console.log(
              "Failed to fetch eployees by department:",
              empsData.Message
            );
          }
        } catch (error) {
          console.error(
            "Error fetching eployees by department:",
            error.message
          );
        } finally {
          setloading(false);
        }
      };

      fetchEmployeesByShift();
    }
  }, [superIdData && tokenData && selectedpreShift]);

  const departmentOptions =
    deptData &&
    deptData.map((item) => ({
      value: item.departmentid,
      label: item.Name,
    }));

  // const empOptions = empData && empData.map((item) => ({
  //   value: item.regid,
  //   label: item.UserName,
  // }));

  // console.log(empOptions);

  const shiftOptions =
    shiftTypes &&
    shiftTypes.map((item) => ({
      value: item.shiftid,
      label: item.Name,
    }));

  const filteredData = empData.filter((item) => {
    return (
      (item.UserName && item.UserName.toLowerCase()) ||
      (item.Departmentname && item.Departmentname.toLowerCase())
    );
  });

  // const handleSelectEmployee = (regid) => {
  //   setSelectedEmployees((prev) =>
  //     prev.includes(regid)
  //       ? prev.filter(id => id !== regid)
  //       : [...prev, regid]
  //   );
  // };

  const handleCheckboxClick = (item) => {
    const isSelected = selectedEmployees.some(
      (employee) => employee.UserName === item.UserName
    );

    if (!isSelected) {
      setSelectedEmployees([...selectedEmployees, item]);
    } else {
      setSelectedEmployees(
        selectedEmployees.filter(
          (employee) => employee.UserName !== item.UserName
        )
      );
    }
  };

  const handleDateChange = (dates) => {
    if (dates) {
      setStartDate(dates[0]?.format("YYYY-MM-DD") || "");
      setEndDate(dates[1]?.format("YYYY-MM-DD") || "");
    } else {
      setStartDate("");
      setEndDate("");
    }
  };

  const handleSaveButtonClick = async (e) => {
    e.preventDefault();
    if (superIdData && tokenData) {
      if (
        selectedEmployees.length === 0 ||
        !selectedShift ||
        !startDate ||
        !endDate
      ) {
        alert("Please fill all fields and select at least one employee.");
        return;
      }

      try {
        const requestBody = {
          regid: selectedEmployees.map((employee) => employee.regid),
          shiftid: selectedShift,
          startdate: startDate,
          enddate: endDate,
        };

        console.log(requestBody);
        const response = await fetch(
          `${ROLL_CALL_API_BASE_URL}portal/shifts/assignShifts`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${tokenData}`,
            },
            body: JSON.stringify(requestBody),
          }
        );
        const data = await response.json();
        if (data.status) {
          Swal.fire({
            title: "Success",
            text: "Shift Assigned Sucessfully",
            icon: "success",
          }).then((result) => {
            if (result.isConfirmed || result.isDismissed) {
              window.location.reload();
            }
          });
        } else {
          Swal.fire({
            title: "Error",
            text: "Failed to Request Submit.",
            icon: "error",
          });
        }
      } catch (error) {
        console.error("Error assigning shifts:", error.message);
      }
    }
  };

  const columns = [
    {
      title: "S.No",
      dataIndex: "sno",
      sorter: (a, b) => a.sno - b.sno,
      render: (_, __, index) => index + 1,
    },
    {
      title: "Name",
      dataIndex: "UserName",
      sorter: (a, b) => (a.UserName || "").localeCompare(b.UserName || ""),
    },
    {
      title: "Biometric Id",
      dataIndex: "CardId",
      sorter: (a, b) => new Date(a.CardId) - new Date(b.CardId),
    },
    {
      title: "Department",
      dataIndex: "Departmentname",
      sorter: (a, b) =>
        (a.Departmentname || "").localeCompare(b.Departmentname || ""),
    },
    {
      title: "Designation",
      dataIndex: "Designation",
      sorter: (a, b) =>
        (a.Designation || "").localeCompare(b.designDesignationation || ""),
    },
    {
      title: "Prev Shift",
      dataIndex: "ShiftName",
      sorter: (a, b) => (a.ShiftName || "").localeCompare(b.ShiftName || ""),
    },
    {
      title: "Select",
      align: "center",
      render: (_, record) => (
        <div className="d-flex justify-content-center">
          <input
            type="checkbox"
            checked={selectedEmployees.some(
              (emp) => emp.UserName === record.UserName
            )}
            onChange={() => handleCheckboxClick(record)}
            style={{ cursor: "pointer" }}
          />
        </div>
      ),
    },
  ];

  return (
    <div>
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="add-item d-flex">
              <div className="page-title">
                <nav aria-label="breadcrumb">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/rollcall/dashboard">
                        <i className="fas fa-home fa-lg" />
                      </Link>
                    </li>
                    <h4 className="breadcrumb-item " aria-current="page">
                      Assign Shifts
                    </h4>
                  </ol>
                </nav>
                <h6>Manage your employees shifts</h6>
              </div>
            </div>
            <ul className="table-top-head">
              <TooltipIcons />
              <RefreshIcon />
              <CollapesIcon />
            </ul>
            <div className="page-btn mb-3">
              <Link
                to="#"
                className="btn btn-primary"
                data-bs-toggle="offcanvas"
                data-bs-target="#offcanvasRightViewEmpShifts"
                aria-controls="offcanvasRightViewEmpShifts"
              >
                <i className="fa-regular fa-eye"></i>
              </Link>
            </div>
          </div>
          <div className="card table-list-card">
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
              <div className="search-set p-3"></div>
              <div className="d-flex ms-auto table-dropdown right-content align-items-end flex-wrap row-gap-3">
                <div className="dropdown ml-6">
                  {/* <label
                    className="form-label w-100"
                    htmlFor="department-select"
                  >
                    Department
                  </label> */}
                  <div
                    className="form-control p-0 border-0"
                    style={{ width: 150 }}
                  >
                    <Select
                      showSearch
                      id="department-select"
                      placeholder="Department"
                      value={selectedDep}
                      allowClear
                      onChange={setSelectedDep}
                      options={departmentOptions}
                      style={{ width: 145, height: 38 }}
                      filterOption={(input, option) =>
                        option.label.toLowerCase().includes(input.toLowerCase())
                      }
                    />
                  </div>
                </div>
                <div className="dropdown me-2">
                  {/* <label className="form-label w-100" htmlFor="shift-select">
                    Previous Shift <span className="text-danger ms-1"></span>
                  </label> */}
                  <div
                    className="form-control p-0 border-0"
                    style={{ width: 150 }}
                  >
                    <Select
                      showSearch
                      id="shift-select"
                      placeholder="Previous Shift"
                      value={selectedpreShift}
                      allowClear
                      onChange={setSelectedpreShift}
                      options={shiftOptions}
                      style={{ width: 150, height: 38 }}
                      filterOption={(input, option) =>
                        option.label.toLowerCase().includes(input.toLowerCase())
                      }
                    />
                  </div>
                </div>
                <div className="dropdown me-2">
                  <RangePicker
                    style={{ width: 250 }}
                    value={[
                      startDate ? dayjs(startDate, "YYYY-MM-DD") : null,
                      endDate ? dayjs(endDate, "YYYY-MM-DD") : null,
                    ]}
                    onChange={handleDateChange}
                    format="DD-MM-YYYY"
                    placeholder={["Start Date", "End Date"]}
                  />
                </div>
                {/* <div className="dropdown me-2">
                  <label className="form-label w-100" htmlFor="start-date">
                    Start Date<span className="text-danger ms-1">*</span>
                  </label>
                  <input
                    id="start-date"
                    type="date"
                    className="form-control"
                    style={{ width: 170 }}
                    value={startDate}
                    onChange={(e) => setStartDate(e.target.value)}
                    placeholder="Start Date"
                  />
                </div>
                <div className="dropdown me-2">
                  <label className="form-label w-100" htmlFor="end-date">
                    End Date<span className="text-danger ms-1">*</span>
                  </label>
                  <input
                    id="end-date"
                    type="date"
                    className="form-control"
                    style={{ width: 170 }}
                    value={endDate}
                    onChange={(e) => setEndDate(e.target.value)}
                  />
                </div> */}
                <div className="dropdown me-2">
                  {/* <label className="form-label w-100" htmlFor="shift-select">
                    Assign Shift to<span className="text-danger ms-1">*</span>
                  </label> */}
                  <div
                    className="form-control p-0 border-0"
                    style={{ width: 150 }}
                  >
                    <Select
                      showSearch
                      id="shift-select"
                      placeholder="Assign Shift"
                      value={selectedShift}
                      onChange={setSelectedShift}
                      allowClear
                      options={shiftOptions}
                      style={{ width: 150, height: 38 }}
                      filterOption={(input, option) =>
                        option.label.toLowerCase().includes(input.toLowerCase())
                      }
                    />
                  </div>
                </div>

                {/* Button */}
                <div className="">
                  <button
                    className="btn btn-primary"
                    onClick={handleSaveButtonClick}
                  >
                    <i className="fa-solid fa-check"></i>
                  </button>
                </div>
              </div>
            </div>

            <div className="card-body">
              <div className="table-responsive brand-table">
                {loading ? (
                  <div className="text-center my-4">
                    <Spin size="large" />
                    <p>Loading data...</p>
                  </div>
                ) : filteredData.length > 0 ? (
                  <div className="table-responsive brand-table d-flex  ">
                    <div className="col-10">
                      <Table columns={columns} dataSource={filteredData} />
                    </div>

                    <div className="col-2">
                      <div className="card h-100 border border-end-0 border-bottom-0">
                        <div className="card-header py-2">
                          Selected Employees
                        </div>
                        <div
                          className="card-body"
                          style={{ maxHeight: "400px", overflowY: "auto" }}
                        >
                          {selectedEmployees.length > 0 && (
                            <div className="d-flex justify-content-center mt-2">
                              <button
                                className="btn btn-sm btn-primary"
                                onClick={() => setSelectedEmployees([])}
                              >
                                <i className="fa-solid fa-brush me-2"></i>
                                Clear
                              </button>
                            </div>
                          )}

                          {selectedEmployees.length > 0 ? (
                            selectedEmployees.map((employee, index) => (
                              <div
                                className="d-flex my-2 align-items-center ps-2"
                                key={employee.regid || index}
                              >
                                <div className="col-2 p-1">
                                  <input
                                    type="checkbox"
                                    checked
                                    onChange={() =>
                                      handleCheckboxClick(employee)
                                    }
                                    style={{ cursor: "pointer" }}
                                  />
                                </div>
                                <div className="col-10">
                                  <span>{employee.UserName}</span>
                                </div>
                              </div>
                            ))
                          ) : (
                            <div className="text-center text-muted pt-3">
                              Selected employees will appear here
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                ) : (
                  <p className="text-center my-4">No data available</p>
                )}
              </div>
            </div>
          </div>
        </div>
        <CommonFooter />
      </div>
      <ViewEmpShifts />
    </div>
  );
};

export default RollcallAssignShifts;
